import { Question, QuestionTemplate } from '@amzn/awscat-portfolio-assessment-types';
import { Link } from '@amzn/awsui-components-react';

import { toMonthAbvDate } from '../../../common/DateDisplay';
import { constants } from '../../../common/Localization';
import { ColumnDefinition, ColumnTypes } from '../../../common/table/types';
import { ResourceQuestionnaire } from './interfaces';

export  const emailNotificationUrl = 'https://inquire.accelerate.amazonaws.com';
type OnResourceIdClicked =  (resource: ResourceQuestionnaire) => () => void;

export const getApplicationContactColumnDefinition = (onResourceIdClicked: OnResourceIdClicked): ColumnDefinition<ResourceQuestionnaire>[] => {
    return [
        {
            id: 'resourceId',
            type: ColumnTypes.TEXT,
            header: constants.APPLICATION_ID,
            cell: item => <Link onFollow={onResourceIdClicked(item)}>{item.resourceId}</Link>,
        },
        {
            id: 'resourceName',
            type: ColumnTypes.TEXT,
            header: constants.APPLICATION_NAME,
            data: item => item.resourceName || '',
            cell: item => item.resourceName || ''
        },
        {
            id: 'ownerName',
            type: ColumnTypes.TEXT,
            header: constants.BUSINESS_OWNER_NAME,
            cell: item => item.ownerName,
        },
        {
            id: 'ownerEmail',
            type: ColumnTypes.TEXT,
            header: constants.BUSINESS_OWNER_EMAIL,
            cell: item => item.ownerEmail,
        },
        {
            id: 'ownerPhone',
            type: ColumnTypes.TEXT,
            header: constants.BUSINESS_OWNER_PHONE,
            cell: item => item.ownerPhone,
        },
        {
            id: 'status',
            type: ColumnTypes.TEXT,
            header: constants.REQUEST_STATUS,
            cell: item => item.status,
        },
        {
            id: 'dueDate',
            type: ColumnTypes.TEXT,
            header: constants.DUE_DATE,
            data: item => item.dueDate.length > 0 ? toMonthAbvDate(new Date(item.dueDate)) : '',
            cell: item => item.dueDate.length > 0 ? toMonthAbvDate(new Date(item.dueDate)) : '',
        }
    ];
};

export const getServerContactColumnDefinition = (onResourceIdClicked: OnResourceIdClicked): ColumnDefinition<ResourceQuestionnaire>[] => {
    return [
        {
            id: 'resourceId',
            type: ColumnTypes.TEXT,
            header: constants.SERVER_ID,
            cell: item => <Link onFollow={onResourceIdClicked(item)}>{item.resourceId}</Link>,
        },
        {
            id: 'ownerName',
            type: ColumnTypes.TEXT,
            header: constants.SERVER_OWNER_NAME,
            cell: item => item.ownerName,
        },
        {
            id: 'ownerEmail',
            type: ColumnTypes.TEXT,
            header: constants.SERVER_OWNER_EMAIL,
            cell: item => item.ownerEmail,
        },
        {
            id: 'ownerPhone',
            type: ColumnTypes.TEXT,
            header: constants.SERVER_OWNER_PHONE,
            cell: item => item.ownerPhone,
        },
        {
            id: 'status',
            type: ColumnTypes.TEXT,
            header: constants.REQUEST_STATUS,
            cell: item => item.status,
        },
        {
            id: 'dueDate',
            type: ColumnTypes.TEXT,
            header: constants.DUE_DATE,
            data: item => item.dueDate.length > 0 ? toMonthAbvDate(new Date(item.dueDate)) : '',
            cell: item => item.dueDate.length > 0 ? toMonthAbvDate(new Date(item.dueDate)) : '',
        }
    ];
};

export const getDatabaseContactColumnDefinition = (onResourceIdClicked: OnResourceIdClicked): ColumnDefinition<ResourceQuestionnaire>[] => {
    return [
        {
            id: 'resourceId',
            type: ColumnTypes.TEXT,
            header: constants.DATABASE_ID,
            cell: item => <Link onFollow={onResourceIdClicked(item)}>{item.resourceId}</Link>,
        },
        {
            id: 'ownerName',
            type: ColumnTypes.TEXT,
            header: constants.DATABASE_OWNER_NAME,
            cell: item => item.ownerName,
        },
        {
            id: 'ownerEmail',
            type: ColumnTypes.TEXT,
            header: constants.DATABASE_OWNER_EMAIL,
            cell: item => item.ownerEmail,
        },
        {
            id: 'ownerPhone',
            type: ColumnTypes.TEXT,
            header: constants.DATABASE_OWNER_PHONE,
            cell: item => item.ownerPhone,
        },
        {
            id: 'status',
            type: ColumnTypes.TEXT,
            header: constants.REQUEST_STATUS,
            cell: item => item.status,
        },
        {
            id: 'dueDate',
            type: ColumnTypes.TEXT,
            header: constants.DUE_DATE,
            data: item => item.dueDate.length > 0 ? toMonthAbvDate(new Date(item.dueDate)) : '',
            cell: item => item.dueDate.length > 0 ? toMonthAbvDate(new Date(item.dueDate)) : '',
        }
    ];
};

export const questionTypes = [
    { value: 'text', label: constants.TEXT },
    { value: 'number', label: constants.NUMBER },
    { value: 'select', label: constants.DROPDOWN },
];

export const emptyQuestionTemplate: QuestionTemplate = {
    label: constants.NEW_QUESTION,
    answerType: 'text',
    questionText: '',
    validation: undefined,
    notes: '',
    active: true,
    resourceReference: ''
};

export const emptyQuestion: Question = {
    label: constants.NEW_QUESTION,
    answerType: 'text',
    questionText: '',
    notes: '',
    active: true,
    resourceReference: '',
    category: '',
    hint: '',
    propertyReference: '',
    sourceResourceId: '',
};

export enum TabIds {
    APPLICATION = 'application',
    SERVER = 'server',
    DATABASE = 'database',
}
